






























































































































































































































import Vue from 'vue';

import {Project} from '@/core/entity';
import OutletInput from '@/vue/components/input/Outlet.vue';

import {getProjectQL} from './graphql';

export default Vue.extend({
  components: {
    'input-outlet': OutletInput,
  },

  props: {
    projectId: String as () => string,
    loading: Boolean as () => boolean,
  },

  apollo: {
    project: {
      query: getProjectQL,
      variables() {
        return {projectId: this.projectId};
      },
      skip() {
        return this.projectId === 'new' || !this.projectId;
      },
      fetchPolicy: 'network-only',
    },
  },

  data() {
    return {
      file: null as File | null,
      form: this.$form.createForm(this),
      project: null as Project | null,
    };
  },

  watch: {
    projectId(newVal: string | null) {
      if (!newVal) {
        this.project = null;

        // reset form
        this.form.setFieldsValue({
          name: '',
          note: '',
          outlets: [],
        });

        this.file = null;
      }
    },

    project(newVal: Project | null) {
      this.form.setFieldsValue({
        name: newVal ? newVal.name : '',
        note: newVal ? newVal.note : '',
      });
    },
  },

  computed: {
    fileHelp(): string {
      if (!this.file) {
        return 'You must provide a single CSV file.';
      }

      return '';
    },

    fileValidateStatus(): string {
      if (!this.file) {
        return 'error';
      }

      return 'success';
    },
  },

  methods: {
    beforeUpload(file: File) {
      this.file = file;
      return false;
    },

    async deleteProject() {
      const {projectId} = this;

      const result = await this.$coreApp.project.remove(
          projectId,
          this.presenter('Project removed.', 'Unable to remove project:'),
          undefined,
          undefined,
          [`listClientProject`],
      );
    },

    handleSubmit() {
      this.form.validateFields((errors: Error[], val: any) => {
        if (errors === null && this.file) {
          this.$emit('save', {
            ...val,
            file: this.file,
          });
        }
      });
    },

    presenter(success: string, failure: string) {
      return (err: Error | null, result: Project | null, loading: boolean) => {
        if (loading) {
          // request in progress
          return;
        }

        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else {
          this.$message.success(success);

          this.$router.back();
        }
      };
    },

    showDeleteConfirm() {
      const {deleteProject} = this;
      this.$confirm({
        title: 'Are you sure you want to delete this project?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          deleteProject();
        },
      });
    },
  },
});
